import tw, { styled, css } from 'twin.macro';
import { StyledProps as Props } from '../../../types/util.types';

export const buttonContainer = styled.div<Props>(() => [
  css`
    ${tw`flex justify-end mt-40`};
  `
]);
